var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdPageUnavailable',{attrs:{"path":['decor.scenarios', 'decor.scenarios.actors']}},[_c('v-layout',[_c('v-flex',[_c('ActorPanel')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }